import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ClutchIcon } from "../../../app-constants";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/game_update/associatesslider.webp";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1801 },
    items: 2.1,
  },
  desktop: {
    breakpoint: { max: 1800, min: 1600 },
    items: 1.8,
  },
  smalldesktop: {
    breakpoint: { max: 1599, min: 1400 },
    items: 1.65,
  },
  landscape: {
    breakpoint: { max: 1399, min: 1200 },
    items: 1.8,
  },
  tablet: {
    breakpoint: { max: 1199, min: 900 },
    items: 1.4,
  },
  mobilelg: {
    breakpoint: { max: 899, min: 667 },
    items: 1.1,
  },
  mobile: {
    breakpoint: { max: 666, min: 0 },
    items: 1,
  },
};

const Associatesslider = (props) => {
  const bg = props.bg;
  return (
    <div
      className="associatesslider p-100 bg_black"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={8}
            xl={8}
            xxl={8}
            className="text-center m-auto"
          >
            <h2>Our Business Associates on Working with Tekrevol</h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Carousel
              responsive={responsive}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={3000}
              showDots={false}
              arrows={false}
            >
              <div className="associates_card">
                <div className="associates_content">
                  <div className="name">
                    Michelle Eberhard
                    <span>CEO, Ultimate Business Quest</span>
                  </div>
                  <p>
                    "Their creativity has been impressive; they’re capable of
                    expanding what we bring to them."
                  </p>
                  <div className="slider-btn">
                    <Link
                      to="https://clutch.co/profile/tekrevol?page=1#review-3252"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                      rel="noopener nofollow"
                    >
                      Check Review
                    </Link>
                  </div>
                </div>
                <div className="associates_rating">
                  <div className="rating_number">5.0</div>

                  <ul>
                    <li>
                      Quality <span>5.0</span>
                    </li>
                    <li>
                      Schedule <span>4.0</span>
                    </li>
                    <li>
                      Cost <span>5.0</span>
                    </li>
                    <li>
                      Willing to Refer <span>5.0</span>
                    </li>
                  </ul>
                  <p>Powered by {ClutchIcon}</p>
                </div>
              </div>
              <div className="associates_card">
                <div className="associates_content">
                  <div className="name">
                    Keith Wagonner
                    <span>Owner & Founder, Button Smasher LLC</span>
                  </div>
                  <p>
                    "I asked TekRevol to complete a year’s worth of work in just
                    a few months, and they’ve delivered."
                  </p>
                  <div className="slider-btn">
                    <Link
                      to="https://clutch.co/profile/tekrevol?page=4#review-111613"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                      rel="noopener nofollow"
                    >
                      Check Review
                    </Link>
                  </div>
                </div>
                <div className="associates_rating">
                  <div className="rating_number">4.0</div>

                  <ul>
                    <li>
                      Quality <span>4.5</span>
                    </li>
                    <li>
                      Schedule <span>4.0</span>
                    </li>
                    <li>
                      Cost <span>5.0</span>
                    </li>
                    <li>
                      Willing to Refer <span>5.0</span>
                    </li>
                  </ul>
                  <p>Powered by {ClutchIcon}</p>
                </div>
              </div>
              <div className="associates_card">
                <div className="associates_content">
                  <div className="name">
                    Luke Sais<span>President, ZombieTag</span>
                  </div>
                  <p>
                    "The TekRevol team goes above and beyond what they’re asked
                    for."
                  </p>
                  <div className="slider-btn">
                    <Link
                      to="https://clutch.co/profile/tekrevol?page=5#review-39646"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                      rel="noopener nofollow"
                    >
                      Check Review
                    </Link>
                  </div>
                </div>
                <div className="associates_rating">
                  <div className="rating_number">5.0</div>

                  <ul>
                    <li>
                      Quality <span>5.0</span>
                    </li>
                    <li>
                      Schedule <span>4.5</span>
                    </li>
                    <li>
                      Cost <span>5.0</span>
                    </li>
                    <li>
                      Willing to Refer <span>5.0</span>
                    </li>
                  </ul>
                  <p>Powered by {ClutchIcon}</p>
                </div>
              </div>
              <div className="associates_card">
                <div className="associates_content">
                  <div className="name">
                    Adam DeGraide <span>CEO, BamBamTastic Games, LLC</span>
                  </div>
                  <p>"Working with them has been fantastic."</p>
                  <div className="slider-btn">
                    <Link
                      to="https://clutch.co/profile/tekrevol?page=6#review-240159"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                      rel="noopener nofollow"
                    >
                      Check Review
                    </Link>
                  </div>
                </div>
                <div className="associates_rating">
                  <div className="rating_number">5.0</div>

                  <ul>
                    <li>
                      Quality <span>5.0</span>
                    </li>
                    <li>
                      Schedule <span>4.0</span>
                    </li>
                    <li>
                      Cost <span>5.0</span>
                    </li>
                    <li>
                      Willing to Refer <span>5.0</span>
                    </li>
                  </ul>
                  <p>Powered by {ClutchIcon}</p>
                </div>
              </div>
              <div className="associates_card">
                <div className="associates_content">
                  <div className="name">
                    Anonymous <span>Owner, Elementeum Games</span>
                  </div>
                  <p>
                    "Their ability to understand the complexities of the project
                    and ease to hit the ground running is very impressive."
                  </p>
                  <div className="slider-btn">
                    <Link
                      to="https://clutch.co/profile/tekrevol?page=7#review-95618"
                      className="border_btn"
                      aria-label="TekRevol Contact"
                      rel="noopener nofollow"
                    >
                      Check Review
                    </Link>
                  </div>
                </div>
                <div className="associates_rating">
                  <div className="rating_number">5.0</div>

                  <ul>
                    <li>
                      Quality <span>4.5</span>
                    </li>
                    <li>
                      Schedule <span>5.0</span>
                    </li>
                    <li>
                      Cost <span>4.0</span>
                    </li>
                    <li>
                      Willing to Refer <span>4.5</span>
                    </li>
                  </ul>
                  <p>Powered by {ClutchIcon}</p>
                </div>
              </div>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Associatesslider;
